import { __extends } from "tslib";
import { ShadowMethodBase, _Shader_ShadowMethodBase } from './ShadowMethodBase';
/**
 * ShadowFilteredMethod provides a softened shadowing technique by bilinearly interpolating shadow comparison
 * results of neighbouring pixels.
 */
var ShadowFilteredMethod = /** @class */ (function (_super) {
    __extends(ShadowFilteredMethod, _super);
    function ShadowFilteredMethod() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ShadowFilteredMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return ShadowFilteredMethod.assetType;
        },
        enumerable: false,
        configurable: true
    });
    ShadowFilteredMethod.assetType = '[asset ShadowFilteredMethod]';
    return ShadowFilteredMethod;
}(ShadowMethodBase));
export { ShadowFilteredMethod };
import { ShaderBase } from '@awayjs/renderer';
/**
 * _Shader_ShadowFilteredMethod provides a softened shadowing technique by bilinearly interpolating shadow comparison
 * results of neighbouring pixels.
 */
var _Shader_ShadowFilteredMethod = /** @class */ (function (_super) {
    __extends(_Shader_ShadowFilteredMethod, _super);
    function _Shader_ShadowFilteredMethod() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Creates a new _Shader_ShadowFilteredMethod.
     */
    _Shader_ShadowFilteredMethod.prototype.init = function (method, shader) {
        _super.prototype.init.call(this, method, shader);
    };
    /**
     * @inheritDoc
     */
    _Shader_ShadowFilteredMethod.prototype._initConstants = function () {
        _super.prototype._initConstants.call(this);
        var fragmentData = this._shader.fragmentConstantData;
        var index = this._fragmentConstantsIndex;
        fragmentData[index] = .5;
        var size = this._method.castingLight.shadowMapper.size;
        fragmentData[index + 1] = size;
        fragmentData[index + 2] = 1 / size;
    };
    /**
     * @inheritDoc
     */
    _Shader_ShadowFilteredMethod.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var dataReg = registerCache.getFreeFragmentConstant();
        this._fragmentConstantsIndex = dataReg.index * 4;
        var code = '';
        var uvReg = registerCache.getFreeFragmentVectorTemp();
        registerCache.addFragmentTempUsages(uvReg, 1);
        var temp = registerCache.getFreeFragmentVectorTemp();
        registerCache.addFragmentTempUsages(temp, 1);
        code += 'mov ' + uvReg + ', ' + this._baseChunk.depthMapCoordReg + '\n' +
            this._baseTexture._getFragmentCode(temp, registerCache, sharedRegisters, uvReg) +
            'mov ' + uvReg + '.w, ' + temp + '.w\n' +
            'add ' + uvReg + '.x, ' + this._baseChunk.depthMapCoordReg + '.x, ' + dataReg + '.z\n' + // (1, 0)
            this._baseTexture._getFragmentCode(temp, registerCache, sharedRegisters, uvReg) +
            'mul ' + temp + '.x, ' + this._baseChunk.depthMapCoordReg + '.x, ' + dataReg + '.y\n' +
            'frc ' + temp + '.x, ' + temp + '.x\n' +
            'sub ' + temp + '.w, ' + temp + '.w, ' + uvReg + '.w\n' +
            'mul ' + temp + '.w, ' + temp + '.w, ' + temp + '.x\n' +
            'add ' + targetReg + '.w, ' + uvReg + '.w, ' + temp + '.w\n' +
            'mov ' + uvReg + '.x, ' + this._baseChunk.depthMapCoordReg + '.x\n' +
            'add ' + uvReg + '.y, ' + this._baseChunk.depthMapCoordReg + '.y, ' + dataReg + '.z\n' + // (0, 1)
            this._baseTexture._getFragmentCode(temp, registerCache, sharedRegisters, uvReg) +
            'mov ' + uvReg + '.w, ' + temp + '.w\n' +
            'add ' + uvReg + '.x, ' + this._baseChunk.depthMapCoordReg + '.x, ' + dataReg + '.z\n' + // (1, 1)
            this._baseTexture._getFragmentCode(temp, registerCache, sharedRegisters, uvReg) +
            // recalculate fraction, since we ran out of registers :(
            'mul ' + temp + '.x, ' + this._baseChunk.depthMapCoordReg + '.x, ' + dataReg + '.y\n' +
            'frc ' + temp + '.x, ' + temp + '.x\n' +
            'sub ' + temp + '.w, ' + temp + '.w, ' + uvReg + '.w\n' +
            'mul ' + temp + '.w, ' + temp + '.w, ' + temp + '.x\n' +
            'add ' + uvReg + '.w, ' + uvReg + '.w, ' + temp + '.w\n' +
            'mul ' + temp + '.x, ' + this._baseChunk.depthMapCoordReg + '.y, ' + dataReg + '.y\n' +
            'frc ' + temp + '.x, ' + temp + '.x\n' +
            'sub ' + uvReg + '.w, ' + uvReg + '.w, ' + targetReg + '.w\n' +
            'mul ' + uvReg + '.w, ' + uvReg + '.w, ' + temp + '.x\n' +
            'add ' + targetReg + '.w, ' + targetReg + '.w, ' + uvReg + '.w\n';
        registerCache.removeFragmentTempUsage(temp);
        registerCache.removeFragmentTempUsage(uvReg);
        _super.prototype._getFragmentCode.call(this, targetReg, registerCache, sharedRegisters);
        return code;
    };
    return _Shader_ShadowFilteredMethod;
}(_Shader_ShadowMethodBase));
export { _Shader_ShadowFilteredMethod };
ShaderBase.registerAbstraction(_Shader_ShadowFilteredMethod, ShadowFilteredMethod);
